export function isDefined(value: any) {
  return value !== null && value !== undefined
}
